import SearchResult from '../components/SearchResults';

const ResultsPage = () => {

    return (
        <div>
            <SearchResult />
        </div>
    );
};

export default ResultsPage;